import TimelineBody from './TimelineBody'
import WorkSectionsBody from './WorkSectionsBody'

export default function TimelineContent({ view, streaming, citations = [] }) {
  if (view.sectioned) {
    return (
      <WorkSectionsBody
        {...view.sections}
        streaming={streaming}
        citations={citations}
      />
    )
  }
  return (
    <TimelineBody
      groups={view.groups}
      orphans={view.orphans}
      trimmed={view.trimmed}
      streaming={streaming}
      citations={citations}
    />
  )
}
